import ReactLoading from "react-loading";
import { useContextSelector } from "use-context-selector";
import {
  TableComponent,
  TdComponent,
  ThComponent,
  TrComponent,
} from "../../../../../../components/TableElements";
import { ExploreItemsContext } from "../../../../../../contexts/ExploreItemsContext";

import { useTheme } from "styled-components";
import { NotFound } from "../../../../../../components/NotFound";
import { ExploreFiltersLoadingContainer } from "../SideFilters/styles";
import * as S from "./styles";
import { NoDataAvailableImage } from "../../../../../../components/NoDataAvailableImage";
import {
  CustomTable,
  CustomTableRow,
} from "../../../../../../components/New/Table/CustomTable";
import { Button } from "../../../../../../components/New/Button";
import { useMediaQuery } from "usehooks-ts";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

export function ExploreTable() {
  const {
    tableData,
    exploreItemsLoading,
    rowLimit,
    changeRowLimit,
    fetchExploreItems,
    fetchExploreItemsCSV,
  } = useContextSelector(ExploreItemsContext, (context) => {
    return context;
  });

  const { t } = useTranslation();

  const theme = useTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.responsiveDesign.sm})`);

  function convertColumnNameValueToLabel(titleString: string) {
    const formattedLabel = titleString.replace(/([A-Z])/g, " $1");
    const capitalizedLabel = formattedLabel.replace(/^./, (str) =>
      str.toUpperCase(),
    );

    return capitalizedLabel;
  }

  function getLastValue(titleString: string) {
    const parts = titleString?.split(".");
    const partialName =
      parts.length > 1 ? parts[parts.length - 1] : titleString;

    const columnName = convertColumnNameValueToLabel(partialName);
    return columnName;
  }

  const handleChangeLimit = (e: React.ChangeEvent<HTMLInputElement>) => {
    changeRowLimit(parseInt(e.target.value));
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      fetchExploreItems();
    }
  };

  const columnNames =
    tableData.length > 0 &&
    Array.from(new Set(tableData.flatMap((obj) => Object.keys(obj)))).map(
      (key) => getLastValue(key),
    );

  return (
    <S.ExploreTableContainer>
      {isMobile && (
        <Button
          isLoading={
            exploreItemsLoading.isLoading && exploreItemsLoading.type === "csv"
          }
          title={t("download")}
          width="100%"
          onClick={() => {
            fetchExploreItemsCSV && fetchExploreItemsCSV();
          }}
          style={{ marginBottom: 16 }}
        />
      )}

      {exploreItemsLoading.type === "data" && exploreItemsLoading.isLoading ? (
        <ExploreFiltersLoadingContainer>
          <ReactLoading
            height={35}
            width={35}
            type={"spin"}
            color={theme.colors["gray-800"]}
          />
        </ExploreFiltersLoadingContainer>
      ) : tableData.length > 0 &&
        columnNames &&
        tableData?.some((obj) => Object?.keys(obj)?.length > 0) ? (
        <>
          <CustomTable
            headers={columnNames}
            style={{
              width: "100%",
              overflow: "visible",
            }}
          >
            {tableData?.map((data, index) => (
              <CustomTableRow key={index}>
                {Object.keys(data).map((key) => (
                  <td key={key}>{data[key]}</td>
                ))}
              </CustomTableRow>
            ))}
          </CustomTable>
          <S.TableTitleContainer>
            <div>
              <span>{t("rowLimit")}</span>
              <input
                type="number"
                value={rowLimit}
                onChange={handleChangeLimit}
                onKeyDown={handleKeyDown}
                title={t("rowLimit")}
              />
            </div>
          </S.TableTitleContainer>
        </>
      ) : (
        <NoDataAvailableImage />
      )}
    </S.ExploreTableContainer>
  );
}
